import * as actionTypes from '../constants/actionType';
import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as helpers from "../helpers";

//Action Creators
export const loadMFooterStart = () => {
  return {type: actionTypes.MFOOTER_LOAD_START};
};
export const loadMFooterFail = (error) => {
  console.error(error);
  return {type: actionTypes.MFOOTER_LOAD_FAIL, error};
};
export const loadMFooterSuccess = (data) => {
  return {type: actionTypes.MFOOTER_LOAD_SUCCESS, payload: data};
};


export const initMFooter = () => dispatch => {
  dispatch(loadMFooterStart());

  apiActions
    .loadSingleType(apiValues.nref.mFooter.endpoint)
    .then((result) => {
      const normalized = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mFooter.fieldsUsed);
      const footerDocId = normalized.documentId || normalized.id;

      const loadSubNav = (rel) => {
        if (!rel || typeof rel !== 'object') return Promise.resolve(null);
        const navId = rel.documentId || rel.id;
        if (!navId) return Promise.resolve(null);
        return apiActions
          .loadEndpoint(apiValues.nref.mListNav.endpoint, navId, {
            'populate[navigationLinks][populate]': '*',
          })
          .then((navResult) => {
            const nmListNav = apiActions.itemSelectCamelCaseKeys(navResult, apiValues.nref.mListNav.fieldsUsed);
            nmListNav.navigationLinks = apiActions.arraySelectCamelCaseKeys(
              nmListNav.navigationLinks,
              apiValues.nref.navigationLink.fieldsUsed
            );
            return { key: rel.key || navId, ...nmListNav };
          });
      };

      return Promise.all([
        loadSubNav(normalized.submenuA).then((nav) => {
          if (nav) normalized.submenuA = nav;
        }),
        loadSubNav(normalized.submenuB).then((nav) => {
          if (nav) normalized.submenuB = nav;
        }),
        loadSubNav(normalized.submenuC).then((nav) => {
          if (nav) normalized.submenuC = nav;
        }),
        loadSubNav(normalized.socialList).then((nav) => {
          if (nav) normalized.socialList = nav;
        }),
        loadSubNav(normalized.mobileLinks).then((nav) => {
          if (nav) normalized.mobileLinks = nav;
        }),
        loadSubNav(normalized.mobileContactLinks).then((nav) => {
          if (nav) normalized.mobileContactLinks = nav;
        }),
      ]).then(() => {
        normalized.id = footerDocId;
        dispatch(loadMFooterSuccess(normalized));
      });
    })
    .catch((err) => dispatch(loadMFooterFail(err)));
};

export const searchStart = (query, id) => {
  return {
    type: actionTypes.MFOOTER_SEARCH_START,
    payload: {
      searchQuery: query,
      id,
    }
  };
};

export const searchSuccess = (data) => {
  return {
    type: actionTypes.MFOOTER_SEARCH_SUCCESS,
    payload: data
  };
};

export const doSearch = (query, id) => dispatch => {
  dispatch(searchStart(query, id));

  if (query && query.length > 0) {
    const suggest = apiValues.PROJECT_SUGGEST_QUERY;
    const titlePromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {Title_contains: query, ...suggest})
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));
    const neighborhoodsPromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {Neighborhoods_contains: query, ...suggest})
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));

    return Promise.all([titlePromise, neighborhoodsPromise])
      .then(([titleResults, neighborhoodsResults]) => {
        const results = {suggestedProjects: helpers.mergeArraysWithoutDuplicatesBasedOnProperty(titleResults, neighborhoodsResults, "id")};
        results.id = id;
        dispatch(searchSuccess(results));
      });
  }
  else {
    dispatch(searchSuccess({
      id,
      suggestedProjects: undefined,
      viewProjectsNear: undefined
    }));
    return Promise.resolve();
  }
};

export const toggleSearch = (isSearchOpen, id) => {
  return {
    type: actionTypes.MFOOTER_TOGGLE_SEARCH,
    payload: {
      id,
      isSearchOpen
    }
  };
};
